module.exports = __webpack_public_path__ + "img/CausalGraphCoverFigure.f4a840ea.png";